import { Player, PlayerState } from '@brainfart/shared';

export function ScoreChip({ players, meId }: { players: (Player | PlayerState)[]; meId: string }) {
  const sorted = [...players].sort((a, b) => b.score - a.score);
  const rank = sorted.findIndex(p => p.id === meId) + 1;
  const me = sorted.find(p => p.id === meId);
  if (!me) return null;

  return (
    <div
      className="stamp"
      style={{
        padding: '0.35rem 0.85rem',
        background: rank === 1 ? '#FFC93C' : '#1B1830',
        fontSize: '0.85rem',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        transform: 'rotate(2deg)',
      }}
    >
      <span style={{ color: rank === 1 ? '#15132A' : '#999' }}>
        {rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : `#${rank}`}
      </span>
      <span style={{ color: rank === 1 ? '#15132A' : '#fff' }}>{me.score.toLocaleString()}</span>
    </div>
  );
}
